export function Building({ className = '' }: Readonly<{ className?: string }>) {
  return (
    <span className={`icon ${className}`}>
      <svg
        width="200"
        height="121"
        viewBox="0 0 200 121"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M140 55H114C110.686 55 108 57.6863 108 61V109C108 112.314 110.686 115 114 115H140C143.314 115 146 112.314 146 109V61C146 57.6863 143.314 55 140 55Z"
          fill="var(--clr-container-bg)"
          stroke="var(--clr-border-grey-100)"
        />
        <path
          d="M33 62C40.3333 66 48.3333 67 57 65"
          stroke="var(--clr-title)"
          strokeOpacity="0.2"
          strokeWidth="2.4"
          strokeLinecap="round"
          strokeDasharray="1 7"
        />
        <path
          d="M96.72 25H57.28C52.1548 25 48 28.5817 48 33V107C48 111.418 52.1548 115 57.28 115H96.72C101.845 115 106 111.418 106 107V33C106 28.5817 101.845 25 96.72 25Z"
          fill="var(--clr-container-bg)"
          stroke="var(--clr-border-grey-100)"
        />
        <path
          opacity="0.65"
          d="M122 67H118C116.895 67 116 67.8954 116 69V73C116 74.1046 116.895 75 118 75H122C123.105 75 124 74.1046 124 73V69C124 67.8954 123.105 67 122 67Z"
          fill="var(--clr-general-primary)"
        />
        <path
          opacity="0.4"
          d="M122 83H118C116.895 83 116 83.8954 116 85V89C116 90.1046 116.895 91 118 91H122C123.105 91 124 90.1046 124 89V85C124 83.8954 123.105 83 122 83Z"
          fill="var(--clr-general-primary)"
        />
        <path
          opacity="0.65"
          d="M122 99H118C116.895 99 116 99.8954 116 101V105C116 106.105 116.895 107 118 107H122C123.105 107 124 106.105 124 105V101C124 99.8954 123.105 99 122 99Z"
          fill="var(--clr-general-primary)"
        />
        <path
          opacity="0.4"
          d="M136 67H132C130.895 67 130 67.8954 130 69V73C130 74.1046 130.895 75 132 75H136C137.105 75 138 74.1046 138 73V69C138 67.8954 137.105 67 136 67Z"
          fill="var(--clr-general-primary)"
        />
        <path
          opacity="0.65"
          d="M136 83H132C130.895 83 130 83.8954 130 85V89C130 90.1046 130.895 91 132 91H136C137.105 91 138 90.1046 138 89V85C138 83.8954 137.105 83 136 83Z"
          fill="var(--clr-general-primary)"
        />
        <path
          opacity="0.4"
          d="M136 99H132C130.895 99 130 99.8954 130 101V105C130 106.105 130.895 107 132 107H136C137.105 107 138 106.105 138 105V101C138 99.8954 137.105 99 136 99Z"
          fill="var(--clr-general-primary)"
        />
        <path
          d="M63 63C67 67.6667 71 67.6667 75 63"
          stroke="var(--clr-general-description)"
          strokeLinecap="round"
        />
        <path
          d="M83 63C87 67.6667 91 67.6667 95 63"
          stroke="var(--clr-general-description)"
          strokeLinecap="round"
        />
        <path
          d="M71 77C76.3333 81 81.6667 81 87 77"
          stroke="var(--clr-general-description)"
          strokeLinecap="round"
        />
        <path
          opacity="0.18"
          d="M57.5 75.5C59.1569 75.5 60.5 74.1569 60.5 72.5C60.5 70.8431 59.1569 69.5 57.5 69.5C55.8431 69.5 54.5 70.8431 54.5 72.5C54.5 74.1569 55.8431 75.5 57.5 75.5Z"
          fill="var(--clr-general-primary)"
        />
        <path
          opacity="0.18"
          d="M97.5 75.5C99.1569 75.5 100.5 74.1569 100.5 72.5C100.5 70.8431 99.1569 69.5 97.5 69.5C95.8431 69.5 94.5 70.8431 94.5 72.5C94.5 74.1569 95.8431 75.5 97.5 75.5Z"
          fill="var(--clr-general-primary)"
        />
        <path
          opacity="0.8"
          d="M126 33H122C120.895 33 120 33.8954 120 35V39C120 40.1046 120.895 41 122 41H126C127.105 41 128 40.1046 128 39V35C128 33.8954 127.105 33 126 33Z"
          fill="var(--clr-general-primary)"
        />
        <path
          opacity="0.8"
          d="M94 33H90C88.8954 33 88 33.8954 88 35V39C88 40.1046 88.8954 41 90 41H94C95.1046 41 96 40.1046 96 39V35C96 33.8954 95.1046 33 94 33Z"
          fill="var(--clr-general-primary)"
        />
        <path d="M44 115H156" stroke="var(--clr-border-grey-100)" strokeLinecap="round" />
        <path
          opacity="0.9"
          d="M27 61C20.154 58.7346 18.036 52.7752 22.1484 48.2932C27.4184 51.79 28.9207 56.9613 27 61Z"
          fill="var(--clr-general-primary)"
        />
        <path
          opacity="0.65"
          d="M27 61C23.5032 66.27 17.1005 66.1963 13.4066 61.4682C18.1346 57.7742 23.1337 57.6756 27 61Z"
          fill="var(--clr-general-primary)"
        />
        <path
          opacity="0.45"
          d="M166 96L168 101L173 103L168 105L166 110L164 105L159 103L164 101L166 96Z"
          fill="var(--clr-general-primary)"
        />
        <path
          opacity="0.4"
          d="M109 10.6C110.436 10.6 111.6 9.43593 111.6 7.99999C111.6 6.56405 110.436 5.39999 109 5.39999C107.564 5.39999 106.4 6.56405 106.4 7.99999C106.4 9.43593 107.564 10.6 109 10.6Z"
          fill="var(--clr-general-primary)"
        />
      </svg>
    </span>
  );
}
